<template>
  <div v-if="about">
    <!-- Investor Information -->
    <h3 class="mb-5">Employee Investment & Recruiting</h3>
    <div class="h4 mb-5">顯示於AboutUs頁面</div>
    <!-- Title -->
    <label class="form-item py-5 d-flex">
      <h4 class="w-180px">Title</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.employee_title }}
      </div>
    </label>
    <!-- Description -->
    <label class="form-item py-5 d-flex">
      <h4 class="w-180px">Description</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.employee_description }}
      </div>
    </label>
    <!-- Call to Action -->
    <label class="form-item py-5 d-flex">
      <h4 class="w-180px">Call to Action</h4>
      <div class="flex-grow-1 flex-basis-0">
        {{ about.employee_call_to_action }}
      </div>
    </label>
    <!-- img uploader -->
    <div class="px-5 py-5 d-flex">
      <div class="w-180px">
        <h4 class="mb-10px">Visual</h4>
      </div>
      <div class="flex-grow-1">
        <div
          class="w-305px h-187px bg-cover bg-center ml-auto"
          :style="{
            'background-image': `url(${about.employee_visual})`,
            'border-radius': '6.2px',
            'background-size': 'contain',
          }"
        ></div>
      </div>
    </div>

    <!-- Recruiting Highlight -->
    <h3 class="my-5">Recruiting Highlight</h3>
    <div class="h4 mb-5">可擴充</div>
    <div class="form-item py-5" v-for="(item, i) in about.employee_highlight" :key="i">
      <!-- Highlight -->
      <div class="d-flex align-center">
        <h5 class="w-174px pr-5">Highlight {{ i + 1 }}</h5>
        <div class="flex-grow-1">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
